import { c as _c } from "react/compiler-runtime";
import { MainLink } from "./main-link";
import { MenuLink } from "./menu-link";
import { LinksSchemaType } from "./type";
type TemplateProps = {
  linksArray: LinksSchemaType;
};
export const Template = t0 => {
  const $ = _c(16);
  const {
    linksArray
  } = t0;
  let t1;
  if ($[0] !== linksArray.main || $[1] !== linksArray.mainImage || $[2] !== linksArray.mainImageMobile || $[3] !== linksArray.maintitle) {
    t1 = <MainLink href={linksArray.main} title={linksArray.maintitle} img={linksArray.mainImage} imgMobile={linksArray.mainImageMobile} />;
    $[0] = linksArray.main;
    $[1] = linksArray.mainImage;
    $[2] = linksArray.mainImageMobile;
    $[3] = linksArray.maintitle;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-outline-thin h-3 lg:hidden" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== linksArray.noFollow || $[7] !== linksArray.otherlinks) {
    let t4;
    if ($[9] !== linksArray.noFollow) {
      t4 = linkItem => <MenuLink key={linkItem.href + linkItem.title} title={linkItem.title} href={linkItem.href} img={linkItem.img} isNoFollow={linksArray.noFollow} />;
      $[9] = linksArray.noFollow;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = linksArray.otherlinks.map(t4);
    $[6] = linksArray.noFollow;
    $[7] = linksArray.otherlinks;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="shrink-0"><ul className="grid grid-cols-1 lg:grid-cols-2">{t3}</ul></div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t4) {
    t5 = <div className="flex flex-col-reverse gap-4 lg:h-full lg:flex-row lg:gap-4 xl:gap-8">{t1}{t2}{t4}</div>;
    $[13] = t1;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};